import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

import Parser from 'html-react-parser';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import * as actionsCreatorNews from "./actions";
import * as actionsCreatorNotify from "../../store/root_actions/notifications";
import './css/style.scss';

import { isObjectEmpty } from "../../utils/helpers/common";
import Notify from "../shared/ui/notifications/notify_template";
import Spinner from "../shared/ui/spinner/spinner";
import BackToTop from "../shared/ui/back_to_top/back_to_top";
import ArticleGallery from "./article_gallery.js";
import { Helmet } from 'react-helmet';

class Article extends PureComponent {

  static propTypes = {
    newsArticle: PropTypes.object.isRequired,
    newsArticleInfoCategory: PropTypes.array.isRequired,
    notifyNewsArticle: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    newsArticleGallery: PropTypes.array.isRequired
  };

  componentDidMount() {
    const { history, match } = this.props;
    
    if (history.location.pathname === `/article/${match.params.id}`) {
      this.props.getArticleInit(match.params.id);
    }
  }

  componentWillUnmount() {
    if (this.props.notifyNewsArticle.active) {
      this.props.notifyMessageReset("NewsArticle");
    }
  }

  handleBack = () => {
    if(this.props.location.all) {
      this.props.history.push(`/news/all`);
    } else {
      this.props.history.push(`/news/${this.props.newsArticleInfoCategory[0].id}`);
    }
  }

  render() {
    const { newsArticle, newsArticleInfoCategory, loading, history, newsArticleGallery, notifyNewsArticle } = this.props;
    let articleDate;

    if (newsArticle.action_date) {
      const date = new Date(newsArticle.action_date*1000);
      // const utcDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCHours(), date.getUTCMinutes()));
      const dateOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute:'2-digit'};
      articleDate = date.toLocaleDateString("bg-BG", dateOptions);
    }

    const notifyNewsArticleTemplate = <Notify
      typeGroup={'News'}
      type={notifyNewsArticle.type}
      htmlTemplate={notifyNewsArticle.htmlTemplate}
      active={notifyNewsArticle.active}
      closeNotify={notifyNewsArticle.closeNotify}
      messageHeading={notifyNewsArticle.messageHeading}
      messageBody={notifyNewsArticle.messageBody}
      messageError={notifyNewsArticle.messageError}
      classStyle={'notify-white'}
      classPosition={'notify-relative'} />

    return (
      <div className="entry-wrapper" id="entry-wrapper">
        <Helmet>
          <title>{`${newsArticle.name_bg} | Новини — Easymath.bg`}</title>
        </Helmet>

        <BackToTop range={300} />

        <section className="wrapper with-padding-mobile tile-background title-only">
          <div className="grid-item heading-holder">
            <h1 className="heading-title">Новини</h1>
          </div>
        </section>

        <section className="wrapper with-padding-mobile page-shell">
          <article className="grid-container">
            {
              loading
                ? <Spinner classColor={'spinner-white'} />
                : null
            }
            {
              notifyNewsArticle.htmlTemplate === 'newsArticleCatchError'
                ? notifyNewsArticleTemplate
                : null
            }
            {
              !isObjectEmpty(newsArticle)
              ? <div className="entry-item-header">
                  {
                    history.location.key
                    ? <button type="button" className="entry-back-mobile" onClick={this.handleBack} title="Към категории"><i className="fas fa-chevron-left"></i>Назад</button>
                    : null
                  }
                  <div className="entry-top">
                    <img className="article-img" src={newsArticle.pic} alt={`Статия от категория ${newsArticle.name_bg}`}/>
                  </div>

                  <div className="entry-top entry-top-right-content">
                    {
                      history.location.key
                      ? <button type="button" className="entry-back-desktop" onClick={this.handleBack} title="Към категории"><i className="fas fa-chevron-left"></i>Назад</button>
                      : null
                    }
                    <div className="entry-header">
                      <h2 className="entry-title">{newsArticle.name_bg}</h2>
                      {
                        <div className={`entry-sub-title`}>
                          Категории:
                          {
                            newsArticleInfoCategory.length > 1
                            ? newsArticleInfoCategory.map((category, index) =>
                                <Link to={`/news/${category.id}`} title={`${category.name}`}
                                  className={`entry-article-categories ${newsArticleInfoCategory.length > 1 ? 'list-categories': ''}`}
                                  key={`${index}entryCategories`}>
                                  {`${category.name}`}
                                </Link>
                              )
                            : <Link to={`/news/${newsArticleInfoCategory[0].id}`} title={newsArticleInfoCategory[0].name} className="entry-article-categories">{newsArticleInfoCategory[0].name}</Link>
                          }
                        </div>
                      }
                      <p className="entry-sub-title">
                        {`${articleDate ? `${articleDate} часа.` : ''}`}
                      </p>
                    </div>

                  </div>
                </div>
              : null
            }
            {
              newsArticle.body_bg !== '' && newsArticle.body_bg !== undefined
              ? <div className="entry-item-body">
                  <p className="entry-item-body-content">{ Parser(newsArticle.body_bg)}</p>
                </div>
              : null
            }
            {
              newsArticleGallery.length > 1
                ? <div className="entry-item-body entry-gallery">
                    <Carousel
                      infiniteLoop={true}
                      showStatus={false}
                      autoPlay={true}
                      showThumbs={false}
                      renderArrowPrev={(onClickHandler, hasPrev, label) =>
                        hasPrev && (
                          <button type="button" className="carousel-arrow-control left" onClick={onClickHandler} title={label}>
                            <i className="fas fa-chevron-left"></i>
                          </button>
                        )
                      }
                      renderArrowNext={(onClickHandler, hasNext, label) =>
                        hasNext && (
                          <button type="button" className="carousel-arrow-control right" onClick={onClickHandler} title={label}>
                            <i className="fas fa-chevron-right"></i>
                          </button>
                        )
                      }>
                      { newsArticleGallery.map((image, index) => <ArticleGallery img={image} key={`article-gallery${index}`} classStyle={''} />) }
                    </Carousel>
                  </div>
                : newsArticleGallery.length === 1
                  ? <ArticleGallery img={newsArticleGallery[0]} classStyle={'entry-gallery-single'} />
                  : null
            }
          </article>
        </section>
      </div>
    );
  }
}
const mapStateToProps = ({ notifications, news, loading }) => {

  return {
    newsArticle: news.article,
    newsArticleInfoCategory: news.articleCategories,
    notifyNewsArticle: notifications.newsArticle,
    newsArticleGallery: news.articleImages,
    loading: loading.newsArticleLoading
  };
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...actionsCreatorNews,
    ...actionsCreatorNotify
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Article);